<header>
  <div class="main-header apd-dark-theme">
    <div class="logo-container">
      <a [routerLink]="['/']" class="logo" cdkMonitorElementFocus (click)="clearSearch()">
        <div alt="DigitalWorkOrder"></div>
      </a>
      <div class="title-container">
        <h2 class="app-title">
          <a [routerLink]="['/']">Digital Work Order</a>
        </h2>
        @if (selectedProjectsLabel) {
          <div class="selected-projects">{{ selectedProjectsLabel }}</div>
        }
      </div>
    </div>

    <ng-content select="[apdTool]"></ng-content>

    @if (!offlineMode) {
      <div class="work-center-selection">
        <button [routerLink]="['/profile']">
          <mat-icon class="mat-icon">settings</mat-icon>
        </button>
      </div>
    }

    <div class="language-selection">
      <button class="lang-btn" [matMenuTriggerFor]="languageMenu" title="Select language" aria-label="Select language">
        <mat-icon class="lang-globe" aria-hidden="true">language</mat-icon>
        <span class="lang-code">{{ language | uppercase }}</span>
        <mat-icon class="lang-arrow" aria-hidden="true">arrow_drop_down</mat-icon>
      </button>

      <mat-menu #languageMenu="matMenu" xPosition="before" class="lang-menu">
        <button mat-menu-item (click)="setLanguage('en')">
          <mat-icon [class.lang-active]="language === 'en'">{{
            language === 'en' ? 'radio_button_checked' : 'radio_button_unchecked'
          }}</mat-icon>
          English
        </button>
        <button mat-menu-item (click)="setLanguage('no')">
          <mat-icon [class.lang-active]="language === 'no'">{{
            language === 'no' ? 'radio_button_checked' : 'radio_button_unchecked'
          }}</mat-icon>
          Norsk
        </button>
      </mat-menu>
    </div>

    <div class="toolbar-button-group">
      <button
        routerLink="/support"
        class="support-link"
        cdkMonitorElementFocus
        type="button"
        title="Support"
        aria-label="Support"
      >
        <mat-icon>contact_support</mat-icon>
      </button>
      @if (!hideUserLogin) {
        <app-user class="apd-user">
          <ng-content select="[apdHeaderMenuItems]"></ng-content>
        </app-user>
      }
    </div>
  </div>
  @if (isLoading | async) {
    <mat-progress-bar [style.animation]="'apd-fade-in ' + animationTime" mode="indeterminate"> </mat-progress-bar>
  }
</header>
